export default {
  props: {
    widget: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    options() {
      return this.widget.options
    },
  },
}
